import { StrictMode, startTransition } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

import { getClientEnv } from './services/env.client';
import { initMixpanel } from './services/tracking/mixpanel';

// Initialize Mixpanel early, before React hydrates.
// This ensures UTM params are captured from the initial page load.
const clientEnv = getClientEnv();

if (clientEnv.mixpanelProjectToken) {
  initMixpanel(
    clientEnv.mixpanelProjectToken,
    clientEnv.nodeEnv === 'development'
  );
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>
  );
});
